import api from './../service/apiService'
import { apiUrl } from './../constants/apiUrl'
import { logKafka, detailsInfo, logOtherInfo, catchJSException } from './../service/logService';
import { CheckOut, MTNValidation, PAGEACTIVITY } from './../constants/actionType'
import { errorAction } from './error'
import { updateSCTags, updateSCcustomEvent, tempSCData, scDataDetails } from './../service/dtmTag';
import { updateVzdlSCCustomEvent, tempVzdlSCData } from './../service/vzdl';
import { InHomeUtils } from './../util/inhomeUtils'
import { store } from './../index' 

const getRequest = (contactInfo, reqType, visitId) => {
    let request = {}
    try {
        if (reqType === 'name') {
            request = {
                firstname: contactInfo.fName,
                lastname: contactInfo.lName
            }
        }

        if (reqType === 'contactinfo') {
            // mtn: contactInfo.tnType === "Other" ? "" : `${contactInfo.phoneNo.ph1}${contactInfo.phoneNo.ph2}${contactInfo.phoneNo.ph3}`,
            // altTn: contactInfo.tnType === "Other" ? `${contactInfo.phoneNo.ph1}${contactInfo.phoneNo.ph2}${contactInfo.phoneNo.ph3}` : "",
            let autoPayInCart = store && store.getState() && store.getState().cart && store.getState().cart.autoPayinCart;
            const mtnRemoveDots = contactInfo.phoneNo.ph1.replace(/\./g,'');  
            request = {
                firstName: contactInfo.fName,
                lastName: contactInfo.lName,
                email: contactInfo.eMailId,
                mtn: contactInfo.tnType === "Other" ? "" : mtnRemoveDots,
                altTn: contactInfo.tnType === "Other" ? mtnRemoveDots : "",
                numtype: contactInfo.tnType,
                smsOptIn: contactInfo.isSMSOptIn ? "Y" : "N",
                digitalbilling: autoPayInCart ? 'Y' : contactInfo.digitalBilling
            }
        }

        if (reqType === 'billingInfo') {
            if (contactInfo.isSameAsServiceAddress === "Y") {
                request = {
                    billingsameassvc: true
                }
            }
            else {
                request = {
                    billingsameassvc: false,
                    addressline1: contactInfo.streetAdress,
                    addressline2: `${contactInfo.unitType}${contactInfo.unitVal}`,
                    city: contactInfo.city,
                    state: contactInfo.state,
                    zip: contactInfo.zipCode
                }
            }
        }
    }
    catch (ex) {
        catchJSException('personalInfo', visitId, 'action_getRequest', ex);
    }

    return JSON.stringify(request);
}

export const validateName = (dispatch, contactInfo, visitId) => {
    try {
        let url = apiUrl().validateName;


        api(url, 'POST', getRequest(contactInfo, 'name', visitId)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: CheckOut.onNameValidation,
                    value: response.data
                });
                if (InHomeUtils.isNotNull(response.data)) {
                    if (((InHomeUtils.isNotNull(response.data.isValidFirstName) && !response.data.isValidFirstName) || (InHomeUtils.isNotNull(response.data.isValidLastName) && !response.data.isValidLastName))) {

                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CI, 'INVALIDNAME', PAGEACTIVITY.UA));
                    }
                }
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CI, 'Validate Name API Failure', PAGEACTIVITY.UA));
            }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:validateName,errorMessage:${error.message}`;
                logKafka("ERROR", "ValidateName", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('personalInfo', visitId, 'action_validateName', ex);
    }
};

export const updateBAUCCStatus = (dispatch, val) => {
    dispatch({
        type: CheckOut.updateBAUCC,
        value: val
    })
}

export const sendOTP = (dispatch, val, isOtpBypassFlow, visitId) => {
    try {
        let url = apiUrl().sendOTP;

        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Sending code", isLoaderImg: "loader" }
        });
        api(url, 'POST', val).then(response => {
            if (isOtpBypassFlow) {
                response = {
                    "meta": {
                        "code": 200.01,
                        "description": "  Validate ValidateMTNOwnership Successful.",
                        "timestamp": "Mon Apr 01 22:53:51 IST 2019"
                    },
                    "data": {
                        "result": "SUCCESS"
                    }
                }
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.result) && response.data.result === "SUCCESS") {
                dispatch({
                    type: MTNValidation.updateOTPSentStaus,
                    value: true
                });
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('personalInfo', visitId, 'action_sendOTP', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}

export const updateOTPInfo = (dispatch, val) => {
    dispatch({ type: MTNValidation.updateOTPInfo, value: val })
}

export const updateVZWEligibilityStatus = (dispatch, val) => {
    dispatch({ type: MTNValidation.updateVZWOfferEligibilityStatus, value: val })
}

export const verifyOTP = (dispatch, val, isOtpBypassFlow, noOfAttempts, visitId, isFCPflow, isDoFlow,appState) => {
    try {
        let url = apiUrl().verifyOTP;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Verifying code", isLoaderImg: "loader" }
        });
        api(url, 'POST', val).then(response => {
            if (isOtpBypassFlow) {
                response = {
                    "meta": {
                        "code": 200.01,
                        "description": " VerifyCCPin Successful.",
                        "timestamp": "Mon Apr 01 22:53:51 IST 2019"
                    },
                    "data": {
                        "sessionID": "123456"
                    }
                }
            }            

            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.sessionID) && response.data.sessionID !== "") {
                dispatch({
                    type: MTNValidation.updateVerifyOTP,
                    value: true
                });
                tempSCData.detailPageName = "accord| info and credit- crd chk| vzw authenticated";
                tempVzdlSCData.detail = "info and credit - crd check vzw authenticated | autopay-offer selected";
                tempSCData.installOptions = scDataDetails.initialInstallOptions;
                tempSCData.events = "event5,event13,event14,event63";
                tempSCData.creditCheck = "Pass";
                tempVzdlSCData.creditCheck = "Pass";
                updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName,events");
                updateVzdlSCCustomEvent("checkoutInit","pageViewOmni","detail");
                tempSCData.detailPageName = "accord| info and credit - autopay-offer selected";
                // tempVzdlSCData.detail = "info and credit - autopay-offer selected";
                updateSCcustomEvent("pfbandAutoPayLoad", "ddCheckoutEvent", "detailPageName");
                // updateVzdlSCCustomEvent("pfbandAutoPayLoad", "pageViewOmni", "detail");
                dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })
                dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
                dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })
            }
            else {
                updateSCTags("continue - otp error")
                dispatch({ type: MTNValidation.updateOTPAttempts, value: noOfAttempts + 1 })
                if (noOfAttempts >= 1) {
                    updateBAUCCStatus(dispatch, true)
                }
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('personalInfo', visitId, 'action_verifyOTP', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}


export const validateContactInfo = (dispatch, contactInfo, noOfAttempts, visitId, contactValidationStatus) => {
    try {
        dispatch({

            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Validating the contact information", isLoaderImg: "loader" }
        });
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CI, 'validateContactInfo API and No of attempts :' + noOfAttempts, PAGEACTIVITY.UA));   
        if (noOfAttempts < 2 || contactValidationStatus === 'RETRY') {
            let url = apiUrl().validateContactInfo;
            let apiRequest=getRequest(contactInfo, 'contactinfo', visitId);
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CI, 'Triggering validateContactInfo API and Request Is:' + apiRequest, PAGEACTIVITY.UA));
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CI, 'Triggering validateContactInfo API and URL Is:' + url, PAGEACTIVITY.UA));            
            api(url, 'POST', getRequest(contactInfo, 'contactinfo', visitId)).then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.data)) {
                    dispatch({
                        type: CheckOut.onContactValidation,
                        value: response.data
                    });
                    if(response.meta.code && parseInt(response.meta.code) === 200) {
                        dispatch ({type : CheckOut.contactInfoValidationUpdate,  value : 'SUCCESS'});// SUCCESS
                    }   else {
                        dispatch ({type : CheckOut.contactInfoValidationUpdate,  value : 'RETRY'});
                    }   
                    if (InHomeUtils.isNotNull(response.data.emailIdValidationResult) && InHomeUtils.isNotNull(response.data.emailIdValidationResult.validationResult) && response.data.emailIdValidationResult.validationResult === "INVALID") {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CI, 'INVALIDEMAIL_CNT:' + noOfAttempts, PAGEACTIVITY.UA));
                    }
                    if (InHomeUtils.isNotNull(response.data.mobileNumberValidationResult) && InHomeUtils.isNotNull(response.data.mobileNumberValidationResult.validationResult) && response.data.mobileNumberValidationResult.validationResult === "INVALID") {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CI, 'INVALIDMTN_CNT:' + noOfAttempts, PAGEACTIVITY.UA));
                    }
                }
                else {
                    dispatch({
                        type: CheckOut.onContactValidation,
                        value: { isvalidateddata: true }
                    });
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CI, 'VALIDATE EMAIL-MTN API failure:' + noOfAttempts, PAGEACTIVITY.UA));
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

            })
                .catch(error => {
                    //errorAction("LBO","Checkout",error.message,"applogs",visitId,dispatch,true,"validatecustomerinfo");  
                    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                    let errorMsg = `MethodName:validateContactInfo,errorMessage:${error.message}`;
                    logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs", visitId);
                    errorAction("ERROR", "Checkout", error.message, "applogs", visitId, dispatch, false, "");
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                });
        }
        else {
            dispatch({
                type: CheckOut.onContactValidation,
                value: { isvalidateddata: true }
            });
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
    }
    catch (ex) {
        catchJSException('personalInfo', visitId, 'action_validateContactInfo', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const updateAccordionStatus = (val,dispatch,type) => {
    if(type==='pinfo')
    {
        dispatch({type: CheckOut.updatePersonalInfoAccordionStatus,value: val});    
    }
    else if(type==='credit')
    {
        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })
        dispatch({type: CheckOut.updateCreditCheckAccordionStatus,value: val});     
    }
};

export const validateBillingInfo = (dispatch, billingInfo, onloadCall = false, visitId,runtimeKeys) => {
    try {
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Validating the contact information", isLoaderImg: "loader" }
        });
        if ((billingInfo.noOfAttempts < 3 && !billingInfo.isValidBillingAddress )|| onloadCall || billingInfo.isValidBillingAddress) {
            let url = apiUrl().validateBillingAdress;
            api(url, 'POST', getRequest(billingInfo, 'billingInfo', visitId)).then(response => {
                //200 with no retry Logic 
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && 
                InHomeUtils.isNotNull(response.meta.code) && (response.meta.code === 201.01 ||
                    InHomeUtils.getIndexOf(response.meta.code, '200'))) {
                    dispatch({
                        type: CheckOut.onBillingAddressValidation,
                        value: response.data
                    });
                    dispatch({
                        type: CheckOut.isOnLoadBillingAddressValidation,
                        value: onloadCall
                    });                    
                }
                else if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && 
                InHomeUtils.isNotNull(response.meta.code) && response.meta.code === 500.01 ){
                    //500 with addressvalidation false - Retry Logic
                    if( billingInfo.noOfAttempts < 3){
                        // dispatch({
                        //     type: CheckOut.onBillingAddressSystemError,
                        //     value: response.data
                        // });
                        dispatch({
                            type: CheckOut.onBillingAddressValidation,
                            value: response.data
                        });
                    }
                    else{
                        dispatch({
                            type: CheckOut.onBillingAddressValidation,
                            value: { billingAddress: { addressValidated: true } }
                        });
                    }
                    if (InHomeUtils.isNotNull(response.data.billingAddress) && InHomeUtils.isNotNull(response.data.billingAddress.addressValidated) && !response.data.billingAddress.addressValidated) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CI, 'BILLING ADDR NOT CORRECT_CNT:' + billingInfo.noOfAttempts, PAGEACTIVITY.UA));
                    }
                }
                else {
                    //500 or any other System Issue move to Next Accordion
                    dispatch({
                        type: CheckOut.onBillingAddressValidation,
                        value: { billingAddress: { addressValidated: true } }
                    });
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CI, 'VALIDATE BILL ADDR API FAILURE_CNT:' + billingInfo.noOfAttempts, PAGEACTIVITY.UA));
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }).catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:validateBillingInfo,errorMessage:${error.message}`;
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: CheckOut.onBillingAddressValidation, value: { billingAddress: { addressValidated: false } } });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        }
        else {
            dispatch({
                type: CheckOut.onBillingAddressValidation,
                value: { billingAddress: { addressValidated: true } }
            });

            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
    }
    catch (ex) {
        catchJSException('personalInfo', visitId, 'action_validateBillingInfo', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }

};


export const updateMnhInfo = (dispatch)=> {
    dispatch ({type : CheckOut.contactInfoValidationUpdate,  value : 'SUCCESS'});
    dispatch ( {type:"MNHUPDATEBILLINGINFO",value:true})
    dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' });
}

export const updateMnhCreditCheck = (dispatch) => {
    dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' });
    dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true });
    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' });
    dispatch({ type: 'CREDIT_FAILURE', value: false });
}

export const updateContactInfo = (dispatch, contactInfo) => {
    dispatch({ type: CheckOut.updateContactInfo, value: contactInfo })
    dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'required' });
};

export const updateTNInfo = (dispatch, type, value) => {
    dispatch({ type: 'UPDATE_' + type, value: value });
}

export const updateFormattedTNInfo = (dispatch, value) => {
    dispatch({ type: CheckOut.updateFormattedphone, value: value});
}

export const updateNameInfo = (dispatch, contactInfo) => {
    dispatch({ type: CheckOut.updateNameInfo, value: contactInfo })
};

export const updateBillingAddrInfo = (dispatch, billingInfo) => {
    dispatch({ type: CheckOut.updateBillingAddrInfo, value: billingInfo })
}

export const updateFiosSupportMDN = (dispatch, mdnInfo) => {
    dispatch({ type: CheckOut.updateFiosSupportMDN, value: mdnInfo })
    //dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'required' });
};

export const updateFSMDNInfo = (dispatch, type, value) => {
    dispatch({ type: 'UPDATE_FS' + type, value: value });
}

export const updateFormattedFSMDNInfo = (dispatch, value) => {
    dispatch({ type: CheckOut.updateFormattedFSMDNphone, value: value});
}

